import { z } from "zod";

export const basicInfoSchema = z.object({
  address: z.object({
    city: z.string(),
    state: z.string(),
    street: z.string(),
    zip_code: z.string(),
  }),
  // read-only in UI; still present in payload
  dob: z.string().min(1, "Date of birth is required"),
  email: z.string().email("Must be a valid email"),
  first_name: z.string().min(1, "First name is required"),
  gender: z.string().optional(),
  last_name: z.string().min(1, "Last name is required"),
  mobile: z.string().regex(/^\d{10}$/, "Must be a valid US phone number"),
  preferred_name: z
    .string()
    .regex(/^[a-zA-Z-]*$/, "Only letters and hyphens allowed")
    .nullable()
    .optional(),
  preferred_pronouns: z.string().nullable().optional(),
});

export type BasicInfoFormValues = z.infer<typeof basicInfoSchema>;
